import { axiosInstance } from "@/lib/api/client";

export const getDossier = async ({ dossierId }: { dossierId: string }) =>
  axiosInstance(`/dossiers/${dossierId}`).then((response) => response.data);
